import {ThumbnailFlags} from '../shared/bitsets';

export const POSSIBLE_QUALITIES = ['360', '480', '720', '1080', '2160'];

export function getThumbnailURL(video) {
    let thumbnailURL = 'https://cornhub.objectdepot.net/static/no_thumbnail.jpg';
    if ((video.thumbnails & ThumbnailFlags.HQ) !== 0) {
        thumbnailURL = `https://cornhub.objectdepot.net/thumbnail/${video.link_id}/hq.jpg`;
    } else if ((video.thumbnails & ThumbnailFlags.LQ) !== 0) {
        thumbnailURL = `https://cornhub.objectdepot.net/thumbnail/${video.link_id}/lq.jpg`;
    }

    return thumbnailURL;
}

export function getQualities(video) {
    let qualities = [];
    for (const quality in POSSIBLE_QUALITIES) {
        if ((video.qualities & (1 << quality)) !== 0) {
            qualities.push(POSSIBLE_QUALITIES[quality])
        }
    }

    return qualities;
}
